import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import api from "@/lib/api";
import { reveal } from "@/lib/motion";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 md:py-40 max-w-[1400px] mx-auto px-6 md:px-10"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20">
        <span className="md:col-span-3 overline text-primary">03 — Voices</span>
        <h2 className="md:col-span-8 font-display font-bold tracking-tight text-4xl md:text-6xl leading-[1.02]">
          Students, parents & professionals.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {items.map((t, i) => (
          <motion.figure
            key={t._id || i}
            data-testid={`testimonial-${i}`}
            variants={reveal}
            custom={i}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className={`border border-border p-8 md:p-10 flex flex-col justify-between min-h-[300px] ${
              i % 2 === 1 ? "md:mt-16" : ""
            }`}
          >
            <div className="flex gap-1 mb-6 text-primary">
              {Array.from({ length: t.rating || 5 }).map((_, s) => (
                <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <blockquote className="font-serif-editorial text-2xl md:text-[1.7rem] leading-snug text-foreground">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-8">
              <p className="font-display font-bold text-base">{t.name}</p>
              <p className="font-body text-sm text-muted-foreground">{t.role}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
